import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;
      gsap.registerPlugin( ScrollTrigger );
      let navHeight = $( '.navbar' ).outerHeight();
      let triggerPos = 0;

      if ( $( '#wpadminbar' ).length ) {
        navHeight += $( '#wpadminbar' ).outerHeight();
      }

      triggerPos += navHeight;
      let tl;

      $( '.single-resource' ).each( function( key, val ) {
        if ( window.innerWidth > 1024 ) {
          const height = $( this ).outerHeight();

          tl = gsap.timeline( {
            scrollTrigger: {
              trigger: '.breadcrumbs',
              start: 'top ' + triggerPos,
              end: '=+' + ( height - ( $( '.sidebar-inner' )[0].scrollHeight * 3 ) ),
              scrub: 0,
              pin: '.sidebar-inner',
            },
          } );
        }
      } );

      $( '.category button' ).on( 'toggleAfter', ( event ) => {
        $( $( event.target ).attr( 'data-single-target' ) ).toggle();
        if ( window.innerWidth > 1024 ) {
          const height = $( '.single-resource' ).outerHeight();

          tl = gsap.timeline( {
            scrollTrigger: {
              trigger: '.breadcrumbs',
              start: 'top ' + triggerPos,
              end: '=+' + ( height - ( $( '.sidebar-inner' )[0].scrollHeight * 3 ) ),
              scrub: 0,
              pin: '.sidebar-inner',
            },
          } );
        }
      } );
    },
    finalize: function() {
    },
  };
  app.registerComponent( 'resource', COMPONENT );
} )( app );
